module.exports = __webpack_public_path__ + "static/media/theresistance-main.565f05b1.png";